import _axios from "../api";
import { AuthHeader } from "./auth.header";
import { ACC_ROUTES } from "./route_url";

export const register = async (registerObj) =>
    await _axios.post(ACC_ROUTES.REGISTER, JSON.stringify(registerObj)).then((response) => {
        return response.data;
    });

export const login = async (dataObj) =>
    await _axios.post(ACC_ROUTES.LOGIN, JSON.stringify(dataObj)).then((response) => {
        if (response.data.data.access_token && response.data.data.refresh_token) {
            localStorage.setItem("user", JSON.stringify(response.data.data));
        }

        return response.data;
    });

export const forgotPassword = async (forgotPasswordObj) =>
    await _axios.post(ACC_ROUTES.FORGOT_PASSWORD, JSON.stringify(forgotPasswordObj)).then((response) => {
        return response.data;
    });

export const changePassword = async (currentPassword, newPassword, confirmNewPassword) =>
    await _axios
        .post(
            ACC_ROUTES.CHANGE_PASSWORD,
            JSON.stringify({
                currentPassword,
                newPassword,
                confirmNewPassword,
            }),
            {
                headers: AuthHeader(),
            }
        )
        .then((response) => {
            return response.data;
    });

export const passwordReset = async (resetPasswordObj) =>
    await _axios.post(ACC_ROUTES.PASSWORD_RESET, JSON.stringify(resetPasswordObj)).then((response) => {
        return response.data;
    });

export const logout = () => localStorage.removeItem("user");

export const getProfile = async () =>
    await _axios
        .get(ACC_ROUTES.PROFILE, {
            headers: AuthHeader(),
        })
        .then((response) => {
            return response.data;
        });

export const saveProfile = async (profileObj) =>
    await _axios
        .post(ACC_ROUTES.PROFILE, JSON.stringify(profileObj), {
            headers: AuthHeader(),
        })
        .then((response) => {
            return response.data;
        });
